<template>
  <page>
    <template slot="content">
    <help-content :title="'ﾍﾙｽｹｱに切替えたら歩数がｶｳﾝﾄされなくなった'">
      <template slot="content">
        <div class="text">
          ヘルスケアアプリを開き、<b>概要</b>画面で歩数部分をタップし、次の画面の下部にある<b>データソースとアクセス</b>をタップします。<b>データの読み出しを許可したAPP</b>リストに<b>WeRUN</b>が表示され、<b>スイッチがオン</b>であることをご確認ください。<br><br>
          さらに、下部の<b>データソース</b>リストに<b>利用中のデバイスが一番上</b>に表示されていることをご確認ください。<br><br>
          ※画面右上の「編集」をタップしてデータソースの優先順位を変更することができます。<br>
          ※二つ以上のApple Watchが表示されている場合、使用されていないデバイスをリストの一番下に移動します。
        </div>
        <img class="picture" src="../assets/images/q_and_a/H39.png">
      </template>
    </help-content>
    </template>
  </page>
</template>

<script>
  import HelpContent from '@/components/HelpContent'
  import Page from '@/components/Page'

  export default {
    components: {
      HelpContent,
      Page
    },
    mounted () {
      window.scrollTo(0, 0)
    }
  }
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/pages/Help39.vue